import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as L from 'leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GeoLocationService } from "../../../../shared/services/geo-location.service";
import { LocationService } from "../../../../shared/services/location.service";
import { ViewExplorePhotoComponent } from "../../../explore/components/view-explore-photo/view-explore-photo.component";
import { environment } from "../../../../../environments/environment";
declare var jQuery: any;

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


@Component({
    selector: 'app-map-popup',
    template: `
        <div class="modal-header">
            <h5 class="modal-title">Address: {{address}}<span *ngIf="compareMode"> - LocationId : {{this.locationId}}</span></h5>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding: 0.5rem!important;">
            <div class="container" style="padding:0">
                <div id="contain-map" class="m-auto" style="height: 600px;"></div>
            </div>
            <br>
            <div *ngIf="compareMode">
                <div *ngIf="description">
                    <p>Description: {{description}}</p>
                </div>
                <div *ngIf="nearestLocation.lat">
                    <p>The nearest golden/reward location: {{nearestLocation.address}} - Distance: {{(nearestLocation.distance * 1000) | cNumber}} m</p>
                </div>

                <div *ngIf="!nearestLocation.lat">
                    <p>There is no golden/reward location in  100km</p>
                </div>
                <div class="mt-3 mb-3">
                    <h4>Location gallery</h4>
                    <div class="top-content">
                        <div class="container-fluid">
                            <div id="carousel-example" class="carousel slide" data-ride="carousel" >
                                <div class="carousel-inner row w-100 mx-auto" role="listbox">
                                    <div *ngFor="let photo of photoGallery; let first = first;" class="carousel-item col-12 col-sm-6 col-md-4 col-lg-3 " [ngClass]="{ 'active' : first }">
                                        <img [src]="photo.thumbnail" class="img-fluid mx-auto d-block" alt="img1" style="width: 200px; height: 200px" (click)="openPhoto(photo.id)">
                                        <span class="text-center d-block">{{photo.customer.fullName}}</span>
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#carousel-example" role="button" data-slide="prev" *ngIf="photoGallery.length > 4">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carousel-example" role="button" data-slide="next" *ngIf="photoGallery.length > 4">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./map-popup.css'],
    providers: [GeoLocationService]
})
export class MapPopupComponent implements OnInit {

    @Input() lat;
    @Input() lng;
    @Input() viewOnly: boolean;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    address;
    nearestLocation: any = {}
    description;
    compareMode = false;
    photoGallery = [];
    marker;
    isGolden = false;
    locationId;
    position: any
    // Default location of Norway
    defaultLat = 60.5000209;
    defaultLng = 9.0999715;
    cameraIcon = L.icon({
        iconUrl: require('./../../../../../assets/images/golden-location.png'),
        iconSize: [30, 30], // size of the icon
        popupAnchor: [0, -15] // point from which the popup should open relative to the iconAnchor
    });

    public map;

    constructor(public activeModal: NgbActiveModal,
                private geoLocationService: GeoLocationService,
                private locationService: LocationService,
                protected _modalService: NgbModal
    ) {
    }

    ngOnInit() {
        if (this.viewOnly && this.locationId) { // admin view for choose golden location
            this.locationService.getLocationDetail(this.locationId).subscribe((location: any) => {
                if (location.Data) {
                    this.lat = location.Data.lat;
                    this.lng = location.Data.lng;
                    this.address = location.Data.address;
                    this.photoGallery = location.Data.photo.filter(photo => !photo.isPrimaryLocation);
                    this.description = location.Data.description;
                    this.locationService.getLocationList(1, {
                        lat: this.lat,
                        lng: this.lng,
                    }, 0 , 2).subscribe((nearLocation: any) => {
                        this.initMap(this.lat, this.lng, 10);
                        if (nearLocation.Data && nearLocation.Data.length) {
                            if (nearLocation.Data[0].id != this.locationId) {
                                this.nearestLocation = nearLocation.Data[0];
                                this.addNearestGoldenLocation(this.nearestLocation.lat, this.nearestLocation.lng);
                            } else if (nearLocation.Data.length > 1) {
                                this.nearestLocation = nearLocation.Data[1];
                                this.addNearestGoldenLocation(this.nearestLocation.lat, this.nearestLocation.lng);
                            }
                        }
                    })
                    jQuery('#carousel-example').on('slide.bs.carousel', function (e) {
                        let jQuerye = jQuery(e.relatedTarget);
                        let idx = jQuerye.index();
                        let itemsPerSlide = 4;
                        let totalItems = jQuery('.carousel-item').length;

                        if (idx >= totalItems-(itemsPerSlide-1)) {
                            var it = itemsPerSlide - (totalItems - idx);
                            for (let i=0; i<it; i++) {
                                // append slides to end
                                if (e.direction=="left") {
                                    jQuery('.carousel-item').eq(i).appendTo('.carousel-inner');
                                }
                                else {
                                    jQuery('.carousel-item').eq(0).appendTo('.carousel-inner');
                                }
                            }
                        }
                    });
                }
            })
        } else {
            this.getCurrentLocation();
        }
    }

    openPhoto(photoId) {
        window.open(environment['site'] + environment['prefixDomain'] + 'photo/' + photoId, '_blank')
    }

    public initMap(lat, lng, zoom = 16) {
        // refresh map id
        document.getElementById(
            "contain-map"
        ).innerHTML = `<div id='map' style='width: 100%; height: 100%;'></div>`;

        this.map = L.map("map", {
            center: [lat, lng],
            // Set the initial zoom level, values 0-18, where 0 is most zoomed-out (required)
            zoom: zoom,
            preferCanvas: true
        });

        this.reverseGeo(lat, lng);
        this.createTitleLayer();
        this.addSearchControl();

        //handle click event
        this.map.on('dblclick', e => {
            const coord = e.latlng;
            if (coord) {
                this.reverseGeo(coord.lat, coord.lng);
            }
        });
    }

    addNearestGoldenLocation(lat, lng) {
        this.marker = L.marker([lat, lng], {icon: this.cameraIcon})
            .on('click', (e)=> {
                const modalRef = this._modalService.open(ViewExplorePhotoComponent, {centered: true,  windowClass: "image-card-popup"});
                modalRef.componentInstance.locationDetail = this.nearestLocation
                modalRef.componentInstance.isAdmin = true;
            })
            .addTo(this.map);
    };

    addMarker(lat, lng) {
        // create popup contents
        const customPopup = !this.viewOnly ? `<div class="d-flex"><div class="ml-auto"><button id="applyLocation" type="button" class="btn btn-primary text-white font-family-medium">
                 <i class="fa fa-check"></i></button>
                 <button id="cancelLocation" type="button" class="btn btn-outline-dark"><i class="fa fa-times"></i></button></div></div>` : '';

        // specify popup options
        const customOptions =
            {
                'maxWidth': '290',
            }

        // popover
        this.marker = L.marker([lat, lng])
            .addTo(this.map)
            .bindPopup(this.address + customPopup, customOptions)
            .openPopup();
        this.handleClickEvent();

        this.marker.on("click", (event) => {
            this.handleClickEvent();
        });
    }


    handleClickEvent() {
        const me = this;
        const saveLocation = document.querySelector("#applyLocation");
        const cancelLocation = document.querySelector("#cancelLocation");
        if (!this.viewOnly && saveLocation && cancelLocation) {
            saveLocation.addEventListener('click', () => {
                me.saveLocation();
            });
            cancelLocation.addEventListener('click', () => {
                me.activeModal.close();
            })
        }
    }

    createTitleLayer() {
        // Create a Tile Layer and add it to the map
        L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
            maxZoom: 20,
            subdomains:['mt0','mt1','mt2','mt3']
        }).addTo(this.map);

        // L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        //     attribution: '&copy; <a href="http://osm.org/copyright"></a> contributors',
        //     // Local access tokens key
        //     // accessToken: 'pk.eyJ1IjoibWljaGVsbmd1eWVuIiwiYSI6ImNraHYxbzVucjEzNW8yeHBpdjJldGhpaHcifQ.rsmZChq3K2bHG2gx3gG5pg'
        //     // Live access tokens key
        //     accessToken: 'pk.eyJ1IjoibWljaGVsbmd1eWVuIiwiYSI6ImNrZ2h1ZXVocjA5d2gyeW8wOGQxOGlqamUifQ.2Inx1nlM0hOWVGmSnwNFMg'
        // }).addTo(this.map);
    }

    addSearchControl() {
        // add search control https://github.com/smeijer/leaflet-geosearch
        const provider = new OpenStreetMapProvider();
        const searchControl = new GeoSearchControl({
            provider: provider,
            autoClose: true
        });
        this.map.addControl(searchControl);

        // handler
        this.map.on("geosearch/showlocation", e => {
            if (this.marker) {
                // check
                this.map.removeLayer(this.marker); // remove
            }

            if (e.location.x && e.location.y) {
                this.lat = e.location.y;
                this.lng = e.location.x;
                this.reverseGeo(this.lat, this.lng);
            }
        });
    }

    saveLocation() {
        this.passEntry.emit({address: this.address, lat: this.lat, lng: this.lng});
        this.activeModal.close();
    }

    getCurrentLocation() {
        if ((!this.lat && !this.lng) || (this.lat === 'undefined' && this.lng === 'undefined')) {
            this.setCurrentLocation();
        } else {
            this.initMap(this.lat, this.lng);
        }
    }

    setCurrentLocation() {
        this.geoLocationService.getLocation().subscribe((position) => {
            if (position.coords && position.coords.latitude && position.coords.longitude) {
                this.initMap(position.coords.latitude, position.coords.longitude)
            } else {
                this.initMap(this.defaultLat, this.defaultLng);
            }
        })
    }


    reversing = false;

    reverseGeo(lat, lng) {
        if (!this.reversing) {
            if (this.marker) {
                this.map.removeLayer(this.marker);
            }
            this.reversing = true;
            this.lat = lat;
            this.lng = lng;
            this.geoLocationService.getReverseGeo(lat, lng).subscribe(data => {
                const val = (data || {})
                this.address = val['display_name'];
                this.addMarker(lat, lng);
                setTimeout(() => {
                    this.reversing = false;
                }, 200)

            }, () => {
                this.reversing = false;
            })
        }

    }
}
